exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-facial-detail-wrapper[data-v-1838287c]{display:block}.top-container[data-v-1838287c]{padding:0 20px 20px;display:flex;flex-direction:row;align-items:center}.success-content[data-v-1838287c]{font-size:16px;font-weight:500;color:#405fff;display:flex;flex-direction:row;align-items:center}.success-content img[data-v-1838287c]{width:24px;height:24px}.failure-content[data-v-1838287c]{margin-left:40px;font-size:16px;font-weight:500;color:#f44;display:flex;flex-direction:row;align-items:center}.failure-content img[data-v-1838287c]{width:24px;height:24px}.button-export[data-v-1838287c]{margin-left:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1838287c&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/photo/UploadPhotoFacialDetail.vue
// module id = 457
// module chunks = 0